import DigiraatiButton from '../../common/DigiraatiButton';
import React from 'react';

const DigiraatiTabButton = ({ tabLabel, handleChange, isSelected, value, style }) => {
  const classes = [
    'digiraati-tab-button',
  ]
  if (isSelected) { classes.push('selected') }
  return (
    <button
      role='tab'
      className={classes.join(' ')}
      onClick={event => handleChange(event, value)}
      style={{
        ...style,
      }}
    >
      {tabLabel}  
    </button>
  );
};

export default DigiraatiTabButton;